import { useNavigate } from 'react-router-dom';
import { ArrowRightFromBracketIcon } from '@repo/icons';
import { type TestId } from '@repo/test-id';
import { tr } from '@repo/locale';
import { Button } from '@repo/ui';

import { logout } from '@features/auth';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

interface Props {
  testId: TestId;
}

export default function LogoutButton({ testId }: Props) {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate(ROUTE_PATHS[RouteName.MAP]);
  };

  return (
    <Button
      testId={testId}
      label={tr('actions.logout')}
      leftIcon={ArrowRightFromBracketIcon}
      color="ghost"
      className="text-danger! hover:text-danger-strong! focus:text-danger-strong! w-fit hover:bg-transparent focus:bg-transparent focus:ring-0"
      onClick={handleLogout}
    />
  );
}
